import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import videoMale from "../../assets/videos/DASH_H.mov";
import videoFemale from "../../assets/videos/DASH_M.mov";
import { APP_URL } from "../../util/constants/APP_URL";

const InitialMessage = () => {
    const navigate = useNavigate();

    const user = JSON.parse(localStorage.getItem("asg_user") ?? '{}')
    const [width, setWidth] = useState(window.innerWidth);

    const videoRef = useRef<HTMLVideoElement>(null);

    const getCalcScale = () => {
        const fraction = (width - 170) / 570;
        return fraction < 1 ? '1.4' : fraction > 2 ? '2' : fraction.toString();
    }

    const getRedirect = () => {
        navigate(APP_URL.DASHBOARD.HOME)
    }

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play().catch(error => console.log("Autoplay bloqueado:", error));
        }
    }, []);
    
    useEffect(() => {
            const handleResize = () => {
              setWidth(window.innerWidth);
            };
    
            window.addEventListener('resize', handleResize);
        
            return () => {
                window.removeEventListener('resize', handleResize);
            }
        }, []);
        
    return (
        <div className="message-inspector">
            <div className="background" style={{ scale: getCalcScale() }}>
                <video ref={videoRef} autoPlay>
                    <source src={user.instructor === 'FEMALE' ? videoFemale : videoMale}></source>
                </video>
                <button className="redirect" onClick={getRedirect}></button>
            </div>
        </div>
    )
}

export default InitialMessage